<template>
  <section>
    <div
      v-if="devIndicator"
      class="wrapper fixed z-50 left-0 right-0 top-0 w-full flex gap-1 items-center justify-center py-0.5 text-white bg-primary"
    >
      <bulb-icon />
      <p class="text-xs text-white">Dev Environment</p>
      <div>
        <p
          v-if="!testBaseUrl"
          @click="handleShowBaseUrlDialog"
          class="cursor-pointer"
        >
          <url-link-icon class="w-4 h-4" />
        </p>
        <p v-else class="cursor-pointer" @click="handleShowResetBaseUrlDialog">
          <reset-icon />
        </p>
      </div>
    </div>
    <base-url-form-dialog
      v-if="showBaseUrlDialog"
      :show-dialog="showBaseUrlDialog"
      @closeDialog="closeDialog"
    />
    <reset-base-url
      v-if="showResetBaseUrlDialog"
      :show-reset-dialog="showResetBaseUrlDialog"
      @closeRetryDialog="closeRetryDialog"
      @resetBaseUrl="resetBaseUrl"
    />
  </section>
</template>

<script>
import { TEST_URl } from '@/utils/constants.js'
export default {
  name: 'DevEnvironmentColor',
  data () {
    return {
      localUrl: '',
      showBaseUrlDialog: false,
      showResetBaseUrlDialog: false
    }
  },
  components: {
    BulbIcon: () => import('@/assets/icons/BulbIcon.vue'),
    BaseUrlFormDialog: () =>
      import('@/components/v2/base/BaseUrlFormDialog.vue'),
    ResetBaseUrl: () => import('@/components/v2/base/ResetBaseUrlDialog.vue'),
    UrlLinkIcon: () => import('@/assets/v2/icons/UrlLinkIcon.vue'),
    ResetIcon: () => import('@/assets/v2/icons/ResetIcon2.vue')
  },
  computed: {
    devIndicator () {
      return process.env.VUE_APP_DEV_INDICATOR === 'true'
    },
    testBaseUrl () {
      return this.$store.state.auth.testUrl
    }
  },
  methods: {
    handleShowBaseUrlDialog () {
      this.showBaseUrlDialog = true
    },
    closeDialog () {
      this.showBaseUrlDialog = false
    },
    handleShowResetBaseUrlDialog () {
      this.showResetBaseUrlDialog = true
    },
    closeRetryDialog () {
      this.showResetBaseUrlDialog = false
    },
    resetBaseUrl () {
      this.$store.dispatch('auth/setBaseUrl', this.localUrl)
      this.closeRetryDialog()
      localStorage.removeItem(TEST_URl)
    }
  }
}
</script>

<style scoped>
* {
  font-family: 'Plus Jakarta Sans';
}
.wrapper {
  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
}
h5 {
  font-size: 10px;
}
</style>
